// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
import EndpointsTestingComponent from './endpointsTestingComponent'
import Loading from '../../components-lib/loading'
import ErrorMessage from '../../components-lib/errorMessage'
import Success from '../../components-lib/success'
import {useAxios} from '../../hooks/useAxios'
    export default
        function GetAuthTokenTestingEndpoints(
        props
        )
        {
            const [{response: authToken, isLoading: authTokenLoading, error: authTokenError}, authTokenFetch, authTokenClear] = useAxios()
            const authTokenPost = 
                (authTokenInputParams, responseCallback, errorCallback, cancelCallback) => {
                    authTokenFetch({
                        url: `/Proxy/GetAuthToken`,
                        data: authTokenInputParams,
                        method: "post",
                        responseCallback,
                        errorCallback,
                        cancelCallback
                    });
                }
            function mainRender() {
                return (
                    <div className='container-lg'>
                        <div className='display-4'>GetAuthTokenTestingEndpoints</div>
                    </div>
                )
            }
            return (
                <>
                    {mainRender()}
                    {authTokenLoading && <Loading isSaving/>}
                    {authTokenError && <ErrorMessage error={authTokenError} fetchForInit={authTokenClear}/>}
                    {authToken && <Success/>}
                    <EndpointsTestingComponent
                        authToken={authToken}
                        onAuthTokenPost={authTokenPost}
                        onAuthTokenClear={authTokenClear}
                        {...props}
                    />
                </>
            )
        }
